import isNil from 'lodash/isNil'
import { GeckoComponentModel, GeckoComponentModelType } from 'types'

/**
 * This function is used to determine if a GeckoComponentModel has *a* defined nominal.
 *
 * This is useful to decide if we can calculate derived metrics which require a nominal value
 */
export function componentHasDefinedNominal(
  componentAssetModel: GeckoComponentModel
): boolean {
  switch (componentAssetModel.type) {
    case GeckoComponentModelType.VerticalTankShell: {
      return (
        componentAssetModel.coursesArray.some(
          (sc) =>
            !isNil(sc.wallNominalThickness) ||
            !isNil(sc.coatingNominalThickness)
        ) ||
        componentAssetModel.platesArray.some(
          (plate) =>
            !isNil(plate.wallNominalThickness) ||
            !isNil(plate.coatingNominalThickness)
        )
      )
    }
    case GeckoComponentModelType.HorizontalTankShell: {
      return !isNil(componentAssetModel.wallNominalThickness)
    }
    case GeckoComponentModelType.TankFlatRoof: {
      return (
        !isNil(componentAssetModel.baseNominalThickness) ||
        componentAssetModel.platesArray.some(
          (plate) =>
            !isNil(plate.wallNominalThickness) ||
            !isNil(plate.coatingNominalThickness)
        )
      )
    }
    case GeckoComponentModelType.TankFloor: {
      return (
        !isNil(componentAssetModel.baseNominalThickness) ||
        componentAssetModel.platesArray.some(
          (plate) =>
            !isNil(plate.wallNominalThickness) ||
            !isNil(plate.coatingNominalThickness)
        )
      )
    }
    case GeckoComponentModelType.PipeSection: {
      return !isNil(componentAssetModel.wallNominalThickness)
    }
    case GeckoComponentModelType.PipeElbow: {
      return !isNil(componentAssetModel.wallNominalThickness)
    }
    case GeckoComponentModelType.PipeTJoint: {
      return !isNil(componentAssetModel.wallNominalThickness)
    }
    case GeckoComponentModelType.PipeEccentricReducer: {
      return !isNil(componentAssetModel.wallNominalThickness)
    }
    case GeckoComponentModelType.LegacyBoilerWalls: {
      return componentAssetModel.wallsArray.some(
        (wall) =>
          !isNil(wall.wallNominalThickness) ||
          componentAssetModel.repairRegionsArray.some(
            (repair) =>
              !isNil(repair.wallNominalThickness) ||
              !isNil(repair.coatingNominalThickness)
          )
      )
    }
    case GeckoComponentModelType.LegacyCone: {
      return componentAssetModel.coursesArray.some(
        (course) =>
          !isNil(course.wallNominalThickness) ||
          !isNil(course.coatingNominalThickness)
      )
    }
    case GeckoComponentModelType.Cone: {
      return componentAssetModel.coursesArray.some(
        (course) =>
          !isNil(course.wallNominalThickness) ||
          !isNil(course.coatingNominalThickness)
      )
    }
    // All the following component types do not have nominals stored in their RAM
    case GeckoComponentModelType.LaunchTube: {
      return false
    }
    // going to add nominals in the RAM for
    case GeckoComponentModelType.ShipDeck: {
      return (
        !isNil(componentAssetModel.baseNominalThickness) ||
        componentAssetModel.polygonalPlatesArray.some(
          (plate) =>
            !isNil(plate.wallNominalThickness) ||
            !isNil(plate.coatingNominalThickness)
        )
      )
    }
    case GeckoComponentModelType.BasicShipHull: {
      return false
    }
    case GeckoComponentModelType.Dome: {
      return false
    }
    case GeckoComponentModelType.DomeWall: {
      return false
    }
    case GeckoComponentModelType.FlatCircularFloor: {
      return false
    }
    case GeckoComponentModelType.VerticalTankFoundation: {
      return false
    }
    case GeckoComponentModelType.MachinedForgingSimple: {
      return false
    }
    case GeckoComponentModelType.PressureVesselShell: {
      return !isNil(componentAssetModel.wallNominalThickness)
    }
    case GeckoComponentModelType.HemisphericalHead: {
      return !isNil(componentAssetModel.wallNominalThickness)
    }
    case GeckoComponentModelType.TorisphericalHead: {
      return !isNil(componentAssetModel.wallNominalThickness)
    }
    case GeckoComponentModelType.EllipsoidalHead: {
      return !isNil(componentAssetModel.wallNominalThickness)
    }
    case GeckoComponentModelType.SphereFlatCap: {
      return !isNil(componentAssetModel.wallNominalThickness)
    }
    case GeckoComponentModelType.HoodStraight: {
      return !isNil(componentAssetModel.wallNominalThickness)
    }
    case GeckoComponentModelType.HoodBend: {
      return !isNil(componentAssetModel.wallNominalThickness)
    }
  }
}
